export default function debounce<T extends (...args: any[]) => void>(func: T, delay: number) {
    let timerId: ReturnType<typeof setTimeout>;
    return ((...args: any[]) => {
        clearTimeout(timerId);
        timerId = setTimeout(() => {
            func(...args);
        }, delay);
    }) as T;
}
